"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const DependecyBase_1 = tslib_1.__importDefault(require("./../DependecyBase"));
class CookieTractor extends DependecyBase_1.default {
    constructor(prop) {
        super(prop);
        this.dependency = () => {
            var _b, _c, _d;
            try {
                const consent = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.cookieTractor) === null || _b === void 0 ? void 0 : _b.userConsent) === null || _c === void 0 ? void 0 : _c.consents) !== null && _d !== void 0 ? _d : [];
                return consent.length > 0;
            }
            catch (err) {
                return false;
            }
        };
        this.render = () => {
            const { id, locale = "sv-SE", helmetComponent: Helmet } = this.props;
            return ((0, jsx_runtime_1.jsx)(Helmet, { children: (0, jsx_runtime_1.jsx)("script", { children: `
                    (function() {
                        const elements = document.getElementsByTagName('script')[0];
                        const script = document.createElement('script');
                        script.onload = function () { return window.grebban.gtm.scriptCallback('CookieTractor'); }
                        script.src = 'https://cdn.cookietractor.com/cookietractor.js';
                        script.type = 'text/javascript';
                        script.id = 'CookieTractor'
                        script.setAttribute('data-id', '${id}')
                        script.setAttribute('data-lang', '${locale}')
                        elements.parentNode.insertBefore(script, elements);
                    })();
                ` }) }));
        };
        CookieTractor._componentDependencies.push(this.dependency);
        CookieTractor.instance = this;
    }
}
_a = CookieTractor;
CookieTractor.instance = undefined;
// This feels like a bit of a hack...
CookieTractor._componentDependencies = [];
CookieTractor.dependency = () => _a._componentDependencies.every((dependency) => dependency());
CookieTractor.onScriptLoaded = () => {
    // We can't do anything here, since CookieTractor injects the consent settings directly into the dataLayer.
    // Events can be added. Check documentation: https://www.cookietractor.se/installationsanvisningar
};
exports.default = CookieTractor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZGVwZW5kZW5jaWVzL0Nvb2tpZVRyYWN0b3IvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBRUEsK0VBQWdEO0FBbUJoRCxNQUFNLGFBQWMsU0FBUSx1QkFBcUM7SUFPN0QsWUFBWSxJQUEyQjtRQUNuQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUFLVCxlQUFVLEdBQUcsR0FBRyxFQUFFOztZQUNyQixJQUFJO2dCQUNBLE1BQU0sT0FBTyxHQUFHLE1BQUEsTUFBQSxNQUFBLE1BQU0sYUFBTixNQUFNLHVCQUFOLE1BQU0sQ0FBRSxhQUFhLDBDQUFFLFdBQVcsMENBQUUsUUFBUSxtQ0FBSSxFQUFFLENBQUM7Z0JBQ25FLE9BQU8sT0FBTyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7YUFDN0I7WUFBQyxPQUFPLEdBQUcsRUFBRTtnQkFDVixPQUFPLEtBQUssQ0FBQzthQUNoQjtRQUNMLENBQUMsQ0FBQztRQU9GLFdBQU0sR0FBRyxHQUFHLEVBQUU7WUFDVixNQUFNLEVBQUUsRUFBRSxFQUFFLE1BQU0sR0FBRyxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sRUFBRSxHQUFHLElBQUksQ0FBQyxLQUE4QixDQUFDO1lBRTlGLE9BQU8sQ0FDSCx1QkFBQyxNQUFNLGNBQ0gsNkNBQ0s7Ozs7Ozs7OzBEQVFxQyxFQUFFOzREQUNBLE1BQU07OztpQkFHakQsR0FDUSxHQUNKLENBQ1osQ0FBQztRQUNOLENBQUMsQ0FBQztRQXhDRSxhQUFhLENBQUMsc0JBQXNCLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUMzRCxhQUFhLENBQUMsUUFBUSxHQUFHLElBQUksQ0FBQztJQUNsQyxDQUFDOzs7QUFWTSxzQkFBUSxHQUE4QixTQUFTLENBQUM7QUFFdkQscUNBQXFDO0FBQzlCLG9DQUFzQixHQUFpQixFQUFFLENBQUM7QUFDbkMsd0JBQVUsR0FBRyxHQUFHLEVBQUUsQ0FBQyxFQUFJLENBQUMsc0JBQXNCLENBQUMsS0FBSyxDQUFDLENBQUMsVUFBVSxFQUFFLEVBQUUsQ0FBQyxVQUFVLEVBQUUsQ0FBQyxDQUFDO0FBaUJuRiw0QkFBYyxHQUFHLEdBQUcsRUFBRTtJQUNoQywyR0FBMkc7SUFDM0csa0dBQWtHO0FBQ3RHLENBQUMsQ0FBQztBQTJCTixrQkFBZSxhQUFhLENBQUMifQ==